module.exports = __webpack_public_path__ + "img/start_order.250fe805.svg";